var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v(_vm._s(_vm.title || "Edit Outgoing Message"))]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v(_vm._s(_vm.subTitle)),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _vm.shouldSelectUser
            ? _c(
                "div",
                {
                  staticClass: "rbInputContainer",
                  class: _vm.$style.categorySelect,
                },
                [
                  _c("i", { staticClass: "material-icons icon" }, [
                    _vm._v("person"),
                  ]),
                  _c(
                    "rb-select",
                    {
                      staticClass: "simple",
                      model: {
                        value: _vm.data.userId,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "userId", $$v)
                        },
                        expression: "data.userId",
                      },
                    },
                    [
                      _c("rb-option", { attrs: { value: null } }, [
                        _vm._v("Select User"),
                      ]),
                      _vm._l(_vm.sortedUsers, function (u) {
                        return _c(
                          "rb-option",
                          { key: u.id, attrs: { value: u.id } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(u.firstName) +
                                " " +
                                _vm._s(u.lastName) +
                                " - " +
                                _vm._s(u.email) +
                                " "
                            ),
                            u.type === "ACTIVE"
                              ? [_vm._v("(Power User)")]
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: { type: "button" },
                      on: { click: _vm.createUser },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(" Create User "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("edit-user-message", {
            attrs: { user: _vm.user, "user-account": _vm.userAccount },
            model: {
              value: _vm.data.message,
              callback: function ($$v) {
                _vm.$set(_vm.data, "message", $$v)
              },
              expression: "data.message",
            },
          }),
          _vm.message !== _vm.data.message
            ? _c(
                "div",
                { class: _vm.$style.setDefault },
                [
                  _c("check-box", {
                    attrs: {
                      "check-box-value": true,
                      "check-box-label": "Set as default",
                    },
                    model: {
                      value: _vm.data.setMessageAsDefault,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "setMessageAsDefault", $$v)
                      },
                      expression: "data.setMessageAsDefault",
                    },
                  }),
                  _c("span", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "rbTooltip simple",
                        attrs: { tooltip: "placement:top-start" },
                      },
                      [
                        _vm._v(
                          " Checking this box will set this message as the default message for future hotel directory emails. "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { class: _vm.$style.setDefault },
            [
              _c("check-box", {
                attrs: {
                  "check-box-value": true,
                  "check-box-label": "Send a copy to my email",
                },
                model: {
                  value: _vm.data.copyMe,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "copyMe", $$v)
                  },
                  expression: "data.copyMe",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          class: _vm.$style.vModalDefaultFooter,
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("span", [
            _vm.shouldSelectUser && _vm.data.userId
              ? _c(
                  "button",
                  {
                    staticClass: "rbButton",
                    attrs: { type: "button" },
                    on: { click: _vm.preview },
                  },
                  [_vm._v(" Show Preview ")]
                )
              : _vm._e(),
          ]),
          _c("span", [
            _c(
              "button",
              {
                staticClass: "rbButton",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "button",
              {
                staticClass: "rbButton mainButton",
                attrs: { disabled: _vm.shouldSelectUser && !_vm.data.userId },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("send")]),
                _vm._v(" Send "),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }